"use client";

import { Heart } from "lucide-react";
import { useSavedProducts } from "@/context/SavedProductsContext";

/**
 * Tombol ❤ "Simpan produk" (mig 6270). Keadaan & aksinya dari
 * `useSavedProducts` — akun bila login, perangkat bila tamu.
 *
 *   • `feed` — bulat di baris aksi Jelajah (latar gelap);
 *   • `pill` — pil berlabel di baris Bagikan halaman produk;
 *   • `card` — bulat kecil di kanan-bawah foto kartu Produk Disimpan (melepas).
 *
 * Tak dirender bila fitur mati di jalur ini (`savedProductsEnabledOnPath`).
 * Pemanggil di katalog reseller `/toko` memang tak memasangnya (white-label).
 * Redup-nonaktif selama keadaan ❤ belum diketahui (`ready` false: akun masih
 * dimuat / daftarnya belum tiba) — ketukan di jendela itu dulu menyimpan
 * pembeli yang sudah login sebagai TAMU.
 */
export function SaveProductButton({
  productId,
  variant,
}: {
  productId: string;
  variant: "feed" | "pill" | "card";
}) {
  const { enabled, ready, isSaved, toggle } = useSavedProducts();
  if (!enabled) return null;
  const saved = isSaved(productId);
  const label = saved ? "Hapus dari Produk Disimpan" : "Simpan produk";

  if (variant === "pill") {
    return (
      <button
        type="button"
        onClick={() => toggle(productId)}
        disabled={!ready}
        aria-label={label}
        aria-pressed={saved}
        className={`inline-flex h-10 items-center gap-2 rounded-full border-2 border-shopee px-4 text-sm font-extrabold transition active:scale-95 disabled:opacity-50 ${
          saved ? "bg-shopee text-white" : "text-shopee"
        }`}
      >
        <Heart size={16} className={saved ? "fill-current" : undefined} />
        {saved ? "Disimpan" : "Simpan"}
      </button>
    );
  }

  if (variant === "card") {
    return (
      <button
        type="button"
        onClick={() => toggle(productId)}
        disabled={!ready}
        aria-label={label}
        aria-pressed={saved}
        className="grid h-8 w-8 place-items-center rounded-full bg-white/95 text-shopee shadow-sm transition active:scale-90 disabled:opacity-60"
      >
        <Heart size={16} className={saved ? "fill-current" : undefined} />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => toggle(productId)}
      disabled={!ready}
      aria-label={label}
      aria-pressed={saved}
      className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-white/10 shadow-sm transition active:scale-90 disabled:opacity-50"
    >
      <Heart size={20} className={saved ? "fill-current text-shopee" : "text-white"} />
    </button>
  );
}
